$switch-bg: #f3f4f6;
$switch-active: #82bc44;
$switch-inactive: #d1d5db;
$text-color: #374151;
$text-active: #fff;
$switch-width: 96px;
$switch-height: 36px;
$transition: 0.25s ease;

.field {
	display: flex;
	flex-direction: column;
}

.col3 {
	grid-column: span 3;
}

.col6 {
	grid-column: span 6;
}

.col12 {
	grid-column: span 12;
}

.label {
	font-size: 14px;
	font-weight: 500;
	color: #374151;
}

.switchContainer {
	position: relative;
	width: $switch-width;
	height: $switch-height;
	background-color: $switch-bg;
	border-radius: 9999px;
	cursor: pointer;
	transition: background-color $transition;
	display: flex;
	align-items: center;
	padding: 0;
	user-select: none;
	border: 1px solid $switch-inactive;

	.options {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		z-index: 1;
		padding: 0 12px;
		font-size: 13px;
		font-weight: 500;
		color: $text-color;
	}

	.option {
		z-index: 1;
		transition: color $transition;
	}

	.selected {
		color: $text-active;
	}

	.slider {
		position: absolute;
		top: 2px;
		left: 2px;
		width: calc(50% - 4px);
		height: calc(100% - 4px);
		background-color: $switch-active;
		border-radius: 9999px;
		transition: transform $transition;
		z-index: 0;

		&.left {
			left: 2px;
		}

		&.right {
			left: 7px;
		}
	}

	&.active .slider {
		transform: translateX(100%);
	}
}
